import React, { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { growl } from '@wmgtech/legato'

import { notificationMessageVar } from 'modulesCommon/store'
import { GrowlAlertMessage } from 'components'
import { useLocation } from 'react-router-dom'

const useShowAlert = () => {
  const pathname = useLocation()
  const notifyMessage = useReactiveVar(notificationMessageVar)

  useEffect(() => {
    if (notifyMessage) {
      growl.show(
        {
          className: 'alert-container',
          message: <GrowlAlertMessage title={notifyMessage.title ?? ''} message={notifyMessage.message ?? ''} />,
          colorType: notifyMessage.type ?? 'success',
          containerStyle: notifyMessage.containerStyle ?? 'tint',
          icon: notifyMessage.icon ?? (notifyMessage.type === 'success' ? 'check' : 'warning')
        },
        {
          onClose: () => notificationMessageVar(null)
        }
      )
    }
  }, [notifyMessage])

  useEffect(() => {
    growl.dismiss()
  }, [pathname])

  return null
}

export default useShowAlert
